import { DatePickerAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { ISO_DATE_FORMAT, ISO_HOURS_MINUTES_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment';
import { ISO_FULL_DATE_FORMAT } from '../constants/date-utils';

interface FilterParam {
  [key: string]: Date;
}

interface FilterParamAdjust {
  [key: string]: string;
}

interface RecordDate {
  [key: string]: string;
}

interface DateRange {
  currentDate: string;
  lastMonth: string;
}

export class DateFilterUtils {

  static getCurrentDate(): string {
    return moment().format(ISO_DATE_FORMAT);
  }

  static getCurrentDateUtc(): string {
    return moment().utc().format(ISO_DATE_FORMAT);
  }

  static getCurrentTimeUtc(): string {
    return moment().utc().format(ISO_HOURS_MINUTES_FORMAT);
  }

  static getCurrentDateTimeUtc(): string {
    return moment().utc().format(ISO_FULL_DATE_FORMAT);
  }

  static getDateRange(): DateRange {
    const current = moment();
    const lastMonthDate = moment().subtract(1,'months');

    return {
      currentDate: current.format(ISO_DATE_FORMAT),
      lastMonth: lastMonthDate.format(ISO_DATE_FORMAT)
    }
  }

  static setRangeOnMount(event: MountEvent): void {
    const datePickerApi = event.target as DatePickerAPI;

    const {
      lastMonth,
      currentDate
    } = DateFilterUtils.getDateRange();

    datePickerApi.addRange(lastMonth, currentDate);
  }

  static startDateChange(
    startDate: Date, filter: FilterAPI, startDateFieldName: string, endDateFieldName: string, endDate?: Date
  ): Record<string, Value> | undefined {

    const today = new Date();

    if ( startDate > today ) {

      const record: FilterParam = filter.getRecord() as FilterParam;

      if ( endDate ) {
        const endDt = new Date( endDate );
        record[startDateFieldName] = new Date( endDt.setMonth( endDt.getMonth() - 1) );
        record[endDateFieldName] = new Date( endDate );
      } else {
        const currentDate = new Date();
        record[startDateFieldName] = new Date( currentDate.setMonth( currentDate.getMonth() -1 ) );
        record[endDateFieldName] = today;
      }

      const newRecord: RecordDate = {};

      newRecord[startDateFieldName] = record[startDateFieldName].toISOString().substring(0, 10);
      newRecord[endDateFieldName] = record[endDateFieldName].toISOString().substring(0, 10);

      filter.setRecordMapper(newRecord);

      return newRecord;
    }
    return undefined;
  }

  static endDateChange(
    endDate: Date, filter: FilterAPI, startDateFieldName: string, endDateFieldName: string, startDate?: Date
  ): Record<string, Value> | undefined {

    const today = new Date();
    let record: FilterParamAdjust;

    if ( endDate > today ) {
      record = filter.getRecord() as FilterParamAdjust;
      record[endDateFieldName] = String(today.toISOString().substring(0, 10));
      const startDt = new Date();

      if ( startDate ) {
        record[startDateFieldName] = moment(startDate).format(ISO_DATE_FORMAT);
      } else {
        record[startDateFieldName] = String(moment( startDt.setMonth( startDt.getMonth() - 1) ).toISOString().substring(0, 10));
      }

      const newRecord: RecordDate = {};
      newRecord[startDateFieldName] = record[startDateFieldName];
      newRecord[endDateFieldName] = record[endDateFieldName];
      filter.setRecordMapper(newRecord);
      return newRecord;
    }

    return undefined;
  }

  static anyLessDate(): string {
    return moment().subtract(1,'day').format(ISO_DATE_FORMAT);
  }

  static diffDate(final: Date, initial: Date): number {
    const initialDate = moment(initial)
    const finalDate = moment(final);
    return finalDate.diff(initialDate, 'days');
  }

  static dateIsAfterNow(date: string): boolean {
    if (date) {
      const endDateMoment = moment(date);
      const currentDate = moment();
      const endDateIsBeforeNow = endDateMoment.isAfter(currentDate);
      return endDateIsBeforeNow;
    }

    return false;
  }

}
